@if (authService.isSignedIn() && isReady()) {
    <div class="layout">
        <app-sidebar />

        @if (isAdmin() && !sidebarService.isAdminSidebarEnabled() && !sidebarService.isBelowTabletWidth()) {
            <img src="assets/icons/admin-filled.svg" alt="Burger Icon" class="layout-admin-btn fly-in-from-right" (click)="sidebarService.enableAdminSidebar()" />
        }

        <main class="main-content" [class.main-content-overlay]="(sidebarService.isNavSidebarEnabled() || sidebarService.isAdminSidebarEnabled()) && sidebarService.isBelowTabletWidth()">
            <app-topbar />
            <div class="main-content-item" [class.main-content-item-below]="sidebarService.isBelowTabletWidth()" [class.main-content-item-with-admin-sidebar]="sidebarService.isAdminSidebarEnabled() && !sidebarService.isBelowTabletWidth()">
                <section class="search-top" [class.search-top-hidden]="sidebarService.isBelowMobileWidth()">
                    <div class="search-top-container" [class.search-top-dynamic-margin]="!sidebarService.isBelowTabletWidth()" [class.search-top-full-screen]="sidebarService.isFullScreenRoute() && !sidebarService.isBelowTabletWidth()">
                        <app-search-bar />
                        <div class="divider"></div>
                    </div>
                </section>
                <div
                    class="main-content-item-inner"
                    [class.main-content-item-dynamic-margin]="!sidebarService.isBelowTabletWidth()"
                    [class.main-content-item-full-screen]="sidebarService.isFullScreenRoute() && !sidebarService.isBelowTabletWidth()"
                >
                    @defer (when authService.finishedPermissions()) {
                        <router-outlet />
                    } @placeholder {
                        <app-loading-indicator [size]="'large'" [color]="'secondary'"></app-loading-indicator>
                    }
                </div>
            </div>
        </main>

        <app-admin-sidebar />
    </div>
} @else {
    <router-outlet />
}
<footer></footer>
